import loadable from '@loadable/component';
import loadableModule from '../../components/loadable-module';

const SEOIntroductionParagraphModule = loadableModule({
    LoadableComponent: loadable(() =>
        import(
            /* webpackChunkName: "seo-introduction-paragraph" */
            './'
        )
    ),
    componentName: 'SEOIntroductionParagraph',
});
export default SEOIntroductionParagraphModule;
